import React from 'react';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
    const { isDarkMode } = useTheme();

    return (
        <footer className={`py-8 px-4 ${isDarkMode ? 'bg-gray-900/50' : 'bg-gray-50'} transition-colors`}>
            <div className="max-w-4xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* About Section */}
                    <div>
                        <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>About</h3>
                        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                            SaveMatic is a professional investment and savings calculator that helps you plan your financial future.
                        </p>
                    </div>

                    {/* Resources Section */}
                    <div>
                        <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Resources</h3>
                        <ul className="space-y-2">
                            <li>
                                <a 
                                    href="https://www.investopedia.com/terms/c/compoundinterest.asp" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={`text-sm hover:text-cyan-500 transition-colors ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}
                                >
                                    Understanding Compound Interest
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="https://www.bankrate.com/mortgages/mortgage-calculator/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={`text-sm hover:text-cyan-500 transition-colors ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}
                                >
                                    Mortgage Calculation Guide
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Section */}
                    <div>
                        <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Contact</h3>
                        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                            Have questions or suggestions? We'd love to hear from you!
                        </p>
                        <a 
                            href="mailto:contact@savematic.com" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className={`text-sm hover:text-cyan-500 transition-colors ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}
                        >
                            contact@savematic.com
                        </a>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className={`mt-8 pt-8 border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-200'} text-center`}>
                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                        © {new Date().getFullYear()} SaveMatic. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
